import { render, staticRenderFns } from "./InitialAttributes.vue?vue&type=template&id=33e8c12c&scoped=true&"
import script from "./InitialAttributes.vue?vue&type=script&lang=js&"
export * from "./InitialAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8c12c",
  null
  
)

export default component.exports